module.exports = "/assets/regin-co2-sensor.png";